import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { DataOption, DataOptions } from "@store/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@store/Framework/Types/Common";
import { BlockParsedBaseProps } from "@store/Library/Components/Toolkit/Block/Block";
import { BlockVariantOptionMapper } from "@store/Library/Components/Toolkit/Block/variant/config";

export type BlockVariantSideOption = DataOption<BlockVariantSide>;
export interface BlockVariantSideOptionMapper {
    both: BlockVariantSideOption;
    top: BlockVariantSideOption;
    bottom: BlockVariantSideOption;
}
export type BlockVariantSideOptions = DataOptions<BlockVariantSideOption> & BlockVariantSideOptionMapper;
export type BlockVariantSide = LiteralUnion<keyof BlockVariantSideOptionMapper> | undefined;

export const blockVariantSideOptions: BlockVariantSideOptions = {
    both: { id: "Both", displayName: "Both", isDefault: true },
    top: { id: "Top", displayName: "Top" },
    bottom: { id: "Bottom", displayName: "Bottom" },
};

export interface BlockVariantBaseProps {
    containerCss?: StyledProp<BlockParsedBaseProps>;
    spacerCss?: StyledProp<BlockParsedBaseProps>;
    wrapperCss?: StyledProp<BlockParsedBaseProps>;
}

export interface BlockVariantTypeProps<T extends BlockVariantBaseProps = BlockVariantBaseProps> {
    defaultProps: T;
    staticProps: BlockVariantBaseProps;
}

export type BlockVariantOption<T extends BlockVariantBaseProps = BlockVariantBaseProps> = DataOption<BlockVariant> & {
    type: BlockVariantTypeProps<T>;
    hasSideVariant?: boolean;
};

export type BlockVariantOptions = DataOptions<BlockVariantOption> & BlockVariantOptionMapper;
export type BlockVariant = LiteralUnion<keyof BlockVariantOptionMapper> | undefined;
export type BlockVariantProps = MapperToProps<BlockVariantOptionMapper>;

type MapperToProps<T> = {
    [K in keyof T]: T[K] extends BlockVariantOption<any>
        ? T[K] extends BlockVariantOption<infer X>
            ? X
            : string
        : unknown;
};
